import extendedTablesStyle from '../../../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx'
export default theme => ({
  ...extendedTablesStyle,
  dialogPaper: {
    minWidth: 'calc(65vw + 40px)'
  }
})
